// Full content for the 4 Academy Executive Programs (source: Academy spec doc v1.0)

const COMMON_FORMAT = [
  "2 sessioni a settimana × 90 minuti",
  "Sessione A: Insight & Framework · Sessione B: Executive Lab",
  "Live online in edizione · fascia 18:00–19:30 CET (mar/gio)",
  "Accesso alle registrazioni per 30 giorni dalla fine del percorso",
  "Materiali scaricabili (PDF e template editabili dove previsto)",
  "Attestato di partecipazione al completamento",
  "Edizione Corporate / In-house disponibile su richiesta",
];

export const ACADEMY_PROGRAMS = [
  {
    slug: "ai-governance-for-boards",
    title: "AI Governance for Boards",
    level: "Executive",
    weeks: "6 settimane",
    sessions: "12 sessioni live · 18 ore",
    cohortStatus: "Prossima edizione: in apertura",
    tagline: "Portare l'AI in Consiglio con responsabilità, controlli e decisioni migliori.",
    hook: "Governare l'AI prima che sia l'AI a governare le decisioni.",
    description:
      "Un Executive Program per Board Member, CEO e senior leader che devono comprendere, valutare e governare l'adozione dell'AI con una prospettiva di strategia, rischio, compliance e creazione di valore.",
    audience: [
      "Board Member e Non-Executive Director",
      "CEO, General Manager e C-level",
      "CIO, CISO, CRO, Chief Data/AI Officer",
      "Legal, Compliance, Internal Audit e Risk leader",
      "Senior executive coinvolti in programmi AI e trasformazione digitale",
    ],
    outcomes: [
      "Leggere l'AI con una prospettiva Board, senza diventare tecnici.",
      "Comprendere ruoli, responsabilità e implicazioni dell'EU AI Act.",
      "Disegnare un AI Governance Operating Model.",
      "Costruire AI Risk Register, KPI/KRI e reporting per il Board.",
      "Valutare investimenti e use case AI con criteri di valore e rischio.",
      "Definire un 90-Day Action Plan per rafforzare la governance dell'AI.",
    ],
    curriculum: [
      { week: "01", insight: "AI for Directors — AI, Generative e Agentic AI: cosa deve realmente comprendere un Board. Valore, limiti e implicazioni strategiche.", lab: "Case Lab: mappare dove l'AI crea valore, dove crea rischio e quali decisioni devono salire al Board." },
      { week: "02", insight: "EU AI Act — logica risk-based, attori, classificazione dei sistemi, obblighi e implicazioni per governance e oversight.", lab: "AI Act Lab: classificazione guidata di use case e costruzione della prima compliance/action map." },
      { week: "03", insight: "AI Governance — accountability, ruoli, Three Lines, AI Committee, policy, decision rights ed escalation.", lab: "Design Lab: costruzione dell'AI Governance Operating Model per un'organizzazione tipo." },
      { week: "04", insight: "AI Risk — model risk, data, cyber, privacy, bias, third party, reputazione, human oversight e operational resilience.", lab: "Risk Lab: costruzione dell'AI Risk Register e definizione di controlli e owner." },
      { week: "05", insight: "Strategy & Investment — valutare business case, priorità, benefici, costi, dipendenze, vendor e rischio di investimento.", lab: "Board Simulation: approvare, rinviare o respingere un investimento AI sulla base di un board pack." },
      { week: "06", insight: "Board Oversight — KPI, KRI, reporting, assurance, audit trail e domande che il Board deve porre al management.", lab: "Final Board Lab: simulazione di Board Meeting + 90-Day AI Governance Action Plan." },
    ],
    materials: [
      "AI Governance Toolkit", "AI Governance Operating Model Canvas", "AI Risk Register template",
      "AI Act Board Checklist", "Board Questions for AI Oversight", "AI Investment Evaluation Checklist",
      "90-Day AI Governance Roadmap", "Executive slides e reading pack",
    ],
    priceLaunch: "€1.490", priceStandard: "€1.890",
    corporate: "Programmi Corporate e In-house disponibili su richiesta, con contenuti e format personalizzati per l'organizzazione.",
    faq: [
      { q: "È necessario avere competenze tecniche di AI?", a: "No. Il percorso è progettato per chi deve governare e decidere. La tecnologia viene spiegata solo al livello necessario per una corretta supervisione executive." },
      { q: "Il programma è focalizzato solo sull'AI Act?", a: "No. L'AI Act è un modulo importante, ma il percorso integra strategia, rischio, governance, investimento, reporting e accountability." },
      { q: "Le sessioni sono registrate?", a: "Sì, con accesso per 30 giorni, salvo sessioni o casi che richiedano particolare riservatezza." },
      { q: "È disponibile una versione aziendale?", a: "Sì. La Corporate Edition può essere adattata a Board, leadership team, settore, maturity level e use case specifici." },
    ],
    format: COMMON_FORMAT,
    cohortSize: "12–18 partecipanti",
  },
  {
    slug: "enterprise-risk-mastery",
    title: "Enterprise Risk Master",
    level: "Advanced",
    weeks: "8 settimane",
    sessions: "16 sessioni live · 24 ore",
    cohortStatus: "Prossima edizione: in apertura",
    tagline: "Costruire un ERM moderno che collega rischio, strategia e decisioni del Board.",
    hook: "Dal risk register alla qualità delle decisioni.",
    description:
      "Un percorso executive completo per costruire e far evolvere un Enterprise Risk Management orientato alla strategia, alla creazione di valore e al reporting verso Top Management e Consiglio di Amministrazione.",
    audience: [
      "CRO, Risk Manager ed ERM leader",
      "Internal Audit, Compliance e Governance professional",
      "CFO, Strategy e Planning leader",
      "Board Member e componenti Risk/Audit Committee",
      "Manager chiamati a strutturare o rilanciare un modello ERM",
    ],
    outcomes: [
      "Disegnare un ERM Framework coerente con strategia e governance.",
      "Costruire risk taxonomy, risk universe e metodologie di assessment.",
      "Definire Risk Appetite, tolerance e limits.",
      "Applicare scenario analysis e stress testing.",
      "Integrare emerging risks e interdipendenze.",
      "Costruire KRI, dashboard e reporting executive/Board.",
      "Collegare ERM, business planning e strategic decision-making.",
    ],
    curriculum: [
      { week: "01", insight: "ERM Foundations — ERM, Corporate Governance e creazione di valore. Principi, ruoli e integrazione con strategia.", lab: "Framework Lab: disegnare l'architettura di un ERM Framework." },
      { week: "02", insight: "Risk Universe — risk taxonomy, identificazione, cause-event-impact, stakeholder e fonti informative.", lab: "Identification Lab: costruzione del Risk Universe e della tassonomia." },
      { week: "03", insight: "Risk Assessment — likelihood, impact, velocity, persistence, controls e residual risk.", lab: "Assessment Lab: costruzione di metodologia, scoring e Risk Matrix." },
      { week: "04", insight: "Risk Appetite — Risk Capacity, Appetite, Tolerance, Limits e linkage con gli obiettivi.", lab: "Appetite Lab: definire statement, metriche e threshold per un caso aziendale." },
      { week: "05", insight: "Quantification — scenario analysis, stress testing, sensitivities e metodi quantitativi a supporto delle decisioni.", lab: "Quantification Lab: modellare uno scenario e tradurlo in impatto decisionale." },
      { week: "06", insight: "Emerging Risks — AI, cyber, supply chain, geopolitica, climate e interconnessioni tra rischi.", lab: "Emerging Risk Lab: horizon scanning e interdependency mapping." },
      { week: "07", insight: "KRI & Reporting — KPI/KRI, dashboard, escalation, Board reporting e risk narrative.", lab: "Dashboard Lab: costruzione di un Executive Risk Dashboard." },
      { week: "08", insight: "ERM in Action — integrazione ERM–Strategy–Planning–Investments e ruolo dei Comitati.", lab: "Final Simulation: Risk Committee / Board review + roadmap di evoluzione ERM." },
    ],
    materials: [
      "ERM Framework Canvas", "Risk Universe & Taxonomy template", "Risk Assessment Matrix",
      "Risk Appetite Framework template", "Scenario Analysis worksheet", "Emerging Risk Radar",
      "KRI catalogue starter", "Executive Risk Dashboard template", "Board Risk Report template",
    ],
    priceLaunch: "€1.990", priceStandard: "€2.490",
    corporate: "Corporate / In-house: su richiesta; possibilità di integrare risk workshop e assessment dell'ERM aziendale.",
    faq: [
      { q: "Il percorso è adatto anche a chi deve creare un ERM da zero?", a: "Sì. La sequenza accompagna dalla progettazione del framework fino al reporting e all'integrazione con strategia e pianificazione." },
      { q: "È un corso quantitativo?", a: "Integra componenti quantitative dove servono, ma rimane un Executive Program orientato a governance, metodo e decisioni." },
      { q: "Posso portare casi della mia azienda?", a: "Sì, nei limiti della riservatezza. Gli Executive Lab sono pensati per favorire applicazione e confronto." },
      { q: "Esiste una versione corporate?", a: "Sì. Può includere assessment iniziale, workshop di Risk Appetite, revisione KRI e roadmap ERM." },
    ],
    format: COMMON_FORMAT,
    cohortSize: "12–20 partecipanti",
  },
  {
    slug: "digital-transformation-leadership",
    title: "Digital Transformation Leadership",
    level: "Executive",
    weeks: "6 settimane",
    sessions: "12 sessioni live · 18 ore",
    cohortStatus: "Prossima edizione: in apertura",
    tagline: "Guidare la trasformazione digitale tra strategia, tecnologia, governance e persone.",
    hook: "La trasformazione digitale non è un progetto IT. È una disciplina di leadership.",
    description:
      "Un Executive Program per leader chiamati a trasformare tecnologia e digitale in capacità di business, con una governance solida di priorità, investimenti, operating model, persone e benefici.",
    audience: [
      "CIO, CDO e Technology leader",
      "Transformation Director e Program Leader",
      "CFO e Strategy leader coinvolti negli investimenti digitali",
      "Business executive responsabili di programmi di trasformazione",
      "Manager che aspirano a ruoli Fractional CIO / Digital Advisor",
    ],
    outcomes: [
      "Tradurre strategia di business in Digital & Technology Roadmap.",
      "Comprendere le leve: cloud, data, AI, automation e platform.",
      "Governare portfolio, investimenti, priorità e dipendenze.",
      "Disegnare un Digital Operating Model efficace.",
      "Gestire change, adoption e stakeholder executive.",
      "Misurare benefici, KPI e valore della trasformazione.",
    ],
    curriculum: [
      { week: "01", insight: "Digital Strategy — dalla digital strategy alla business strategy. Capability, maturity e obiettivi di trasformazione.", lab: "Maturity Lab: Digital Maturity Assessment e definizione delle priorità." },
      { week: "02", insight: "Technology Landscape — cloud, data, AI, automation, platforms e architetture: cosa deve governare un leader.", lab: "Roadmap Lab: costruzione di una Technology Transformation Roadmap." },
      { week: "03", insight: "Transformation Governance — portfolio, prioritizzazione, investment governance, budget e decision rights.", lab: "Prioritisation Lab: selezione degli investimenti con criteri valore/rischio/fattibilità." },
      { week: "04", insight: "Operating Model — organizzazione, sourcing, vendor ecosystem, competenze, governance e delivery model.", lab: "Operating Model Lab: disegnare ruoli, forum decisionali e responsabilità." },
      { week: "05", insight: "People & Change — leadership, cultura, comunicazione, adoption, resistenza e capability building.", lab: "Change Lab: stakeholder map e adoption plan su un caso di trasformazione." },
      { week: "06", insight: "Value Creation — benefits realisation, KPI, execution risk, executive reporting e sostenibilità del cambiamento.", lab: "Final Transformation Board: simulazione executive + 90-Day Transformation Agenda." },
    ],
    materials: [
      "Digital Maturity Assessment", "Technology Roadmap template", "Investment Prioritisation Matrix",
      "Digital Operating Model Canvas", "Stakeholder & Change Map", "Benefits Realisation tracker",
      "Executive Transformation Dashboard", "90-Day Transformation Agenda",
    ],
    priceLaunch: "€1.390", priceStandard: "€1.790",
    corporate: "Corporate / In-house: su richiesta; personalizzabile su roadmap, portfolio, operating model e governance della trasformazione.",
    faq: [
      { q: "Serve un background tecnico?", a: "No. Il programma è rivolto a leader che devono governare tecnologia e trasformazione, non configurare piattaforme." },
      { q: "È un percorso per CIO?", a: "È adatto a CIO e Technology leader, ma anche a business executive e transformation leader che devono interagire con tecnologia, investimenti e delivery." },
      { q: "Si affronta anche l'AI?", a: "Sì, come leva di trasformazione insieme a cloud, data, automation e piattaforme, senza sovrapporsi al programma AI Governance for Boards." },
      { q: "È disponibile in-house?", a: "Sì, con adattamento alla roadmap, al portfolio e al modello operativo dell'organizzazione." },
    ],
    format: COMMON_FORMAT,
    cohortSize: "12–20 partecipanti",
  },
  {
    slug: "family-business-governance",
    title: "Family Business Governance",
    level: "Intermediate",
    weeks: "5 settimane",
    sessions: "10 sessioni live · 15 ore",
    cohortStatus: "Prossima edizione: in apertura",
    tagline: "Governance e continuità per famiglie imprenditoriali che vogliono durare nel tempo.",
    hook: "Proteggere il valore dell'impresa significa governare anche la famiglia e la proprietà.",
    description:
      "Un percorso per imprenditori, Next Gen e membri di famiglie proprietarie che vogliono costruire regole, organi e processi capaci di sostenere continuità, successione, crescita e qualità delle relazioni nel tempo.",
    audience: [
      "Imprenditori e famiglie proprietarie",
      "Next Generation e futuri leader",
      "Board Member di imprese familiari",
      "Family Office professional e advisor",
      "Manager esterni inseriti in contesti family-owned",
    ],
    outcomes: [
      "Comprendere le dinamiche tra famiglia, proprietà e impresa.",
      "Disegnare un'architettura di governance coerente con dimensione e maturità.",
      "Preparare la successione e il passaggio generazionale.",
      "Definire ruoli, regole, decision rights e principi di Family Governance.",
      "Gestire Next Gen, conflitti, continuità e apertura a manager esterni.",
      "Costruire una roadmap concreta di Family Business Governance.",
    ],
    curriculum: [
      { week: "01", insight: "Family · Ownership · Business — il modello dei tre sistemi, lifecycle, ruoli e principali fonti di complessità.", lab: "Mapping Lab: mappa di famiglia, proprietà, impresa e principali snodi decisionali." },
      { week: "02", insight: "Governance Architecture — CdA, Assemblea, Family Council, Comitati, management e ruoli della proprietà.", lab: "Governance Lab: disegnare l'architettura degli organi e dei decision rights." },
      { week: "03", insight: "Succession — passaggio generazionale, leadership, readiness, meritocrazia e continuità.", lab: "Succession Lab: scenari di successione, criteri e roadmap." },
      { week: "04", insight: "Ownership & Rules — Family Constitution, policy, ownership principles, informazione e gestione dei conflitti.", lab: "Rules Lab: definire principi e struttura di una Family Constitution." },
      { week: "05", insight: "Next Gen & Longevity — Next Gen development, professionalizzazione, innovazione, family identity e longevity.", lab: "Final Family Governance Lab: costruzione della roadmap a 12–24 mesi." },
    ],
    materials: [
      "Family Business Mapping Canvas", "Governance Architecture template", "Role & Decision Rights matrix",
      "Succession Readiness Checklist", "Family Constitution outline", "Next Gen Development framework",
      "Family Governance Roadmap",
    ],
    priceLaunch: "€1.590", priceStandard: "€1.690",
    corporate: "Corporate / In-house: su richiesta; possibile formato riservato per singola famiglia / proprietà, con sessioni dedicate.",
    faq: [
      { q: "Il percorso è riservato alle grandi famiglie imprenditoriali?", a: "No. È utile anche a imprese familiari di medie dimensioni che vogliono anticipare i problemi di governance prima che diventino conflitti." },
      { q: "È necessario partecipare con più membri della famiglia?", a: "Non è obbligatorio. È possibile prevedere pacchetti o Family Edition per più componenti della stessa proprietà." },
      { q: "Si affrontano aspetti legali e fiscali?", a: "Il focus è governance e organizzazione. Aspetti legali, fiscali e successori specialistici vanno affrontati con professionisti abilitati quando necessario." },
      { q: "È disponibile un percorso riservato alla singola famiglia?", a: "Sì. La Family Edition può essere progettata come engagement riservato con assessment, workshop e roadmap personalizzata." },
    ],
    format: COMMON_FORMAT,
    cohortSize: "10–16 partecipanti",
  },
];

export const getProgram = (slug) => ACADEMY_PROGRAMS.find((p) => p.slug === slug);
